import configureStoreProd from './configureStore.prod.js'
import configureStoreDev from './configureStore.dev.js'

let store = null

const configureStore = appOptions => {
  if (store) {
    return store
  }

  if (process.env.NODE_ENV === 'production') {
    store = configureStoreProd(appOptions)
  } else {
    store = configureStoreDev(appOptions)
  }

  // Enable HMR for reducers only, not the store instance
  if (import.meta.hot) {
    import.meta.hot.accept(['./configureStore.prod.js', './configureStore.dev.js'], () => {
      // Reducers will be updated without recreating the store
    })
  }

  return store
}

export default configureStore
